import React, { useEffect, useRef, useState } from "react";
import { Text } from "components";
import { useNavigate } from "react-router-dom";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import Select from "react-select";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, Legend, Pie, PieChart, } from "recharts";
import AccessRightCard from "pages/AccessRight/AccessRightCard";
import { log } from "react-modal/lib/helpers/ariaAppHider";
import { MdCurrencyRupee } from "react-icons/md";
import PieChartSkeleton from "components/PageSkeleton/PieChartSkeleton";
import CustomTooltip from "components/Graphs/CustomTooltip";

pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const OpdDiscountReports = () => {
    const navigate = useNavigate();
    const [doclist, setdoclist] = useState([]);
    const [Doctors, setDoctors] = useState([]);
    const [paymentType, setpaymentType] = useState([]);
    const [paymentTypeId, setPaymentTypeId] = useState(0);
    const [user, setuser] = useState({});
    const [consultant, setConsultant] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modewiseData, setmodewiseData] = useState([]);
    const [itemwiseTotalOpdCollection, setItemwiseTotalOpdCollection] = useState([]);
    const [dataforbargraph, setDataforbargraph] = useState([]);
    const today = new Date();
    const todayFormatted = today.toISOString().split("T")[0];
    const chartHeight = Math.max(dataforbargraph.length * 40, 150);
    const [userList, setuserlist] = useState([]);

    // start date and end date 


    const [startdate, setStartdate] = useState(
        new Date().toISOString().split("T")[0],
    );
    const [enddate, setEnddate] = useState(
        new Date().toISOString().split("T")[0],
    );

    const now = new Date();
    //  for date formatting
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        return date.toLocaleDateString("en-GB", options).replace(",", "");
    };
    // for time formatting
    const formatTime = (date) => {
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";
        return `${hours}:${minutes} ${ampm}`;
    };
    const selectedconsultant = (e) => {
        setConsultant(e.value);
    }
    const token = sessionStorage.getItem("token");
    const headers = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    // Api for user detail
    const getuser = () => {
        axios
            .post("/api/doctor/userdetail/get", {}, headers)
            .then((response) => {
                setuser(response?.data[0]);
                // console.log(response.data);
            })
            .catch(() => {
                console.log("Error");
            });
    };
    useEffect(() => {
        getuser();
    }, [consultant]);

    // api for all consultants

    const getAllConsultant = () => {
        axios
            .post("/api/doctor/userdetail/getAll", {}, headers)
            .then((response) => {
                const filteruserlist = response.data.filter(
                    (user) => user.user_type_id === 2,
                );
                setuserlist(filteruserlist);
                console.log(filteruserlist);
            })
            .catch(() => {
                console.log("Error");
            });
    };
    useEffect(() => {
        getAllConsultant();
    }, []);

    useEffect(() => {
        // Retrieving data from sessionStorage
        const storeddoclist = sessionStorage.getItem("docAccesslist");

        if (storeddoclist) {
            try {
                // Parsing the JSON string to an array of objects
                const parseddoclist = JSON.parse(storeddoclist);
                setdoclist(parseddoclist);
            } catch (error) {
                console.error("Error parsing JSON:", error);
            }
        }
    }, []);

    const showActionColumn = doclist.some(
        (item) => item.hospital_module_id == 33 && item.view,
    );
    return (
        <>
            {showActionColumn ? (
                <div className="w-full flex flex-col gap-1 bg-[#f4f6ff]">
                    <ToastContainer />
                    {/* filter section */}
                    <div className="filter-section ">
                        {/* start date */}
                        <div>
                            <label className="filter-section-label">Start Date</label>
                            <input
                                type="date"
                                value={startdate}
                                onChange={(e) => setStartdate(e.target.value)}
                                className="filter-section-input"
                                max={todayFormatted}
                            />
                        </div>
                        {/* End date */}
                        <div >
                            <label className="filter-section-label">End Date</label>
                            <input
                                type="date"
                                value={enddate}
                                onChange={(e) => setEnddate(e.target.value)}
                                className="filter-section-input"
                                max={todayFormatted}
                            />
                        </div>

                        {/* Consultant */}
                        {/* Select Consultant */}
                        <div >
                            <Text
                                className=" filter-section-label"
                            >
                                <span >
                                    Select Consultant
                                </span>
                            </Text>

                            <Select
                                name="userdetail_id"
                                options={[
                                    { label: "All", value: 0 }, // Adding the "All Consultants" option
                                    ...(userList?.map((resstate) => ({
                                        label: resstate.name,
                                        value: resstate.id,
                                    })) ?? []),
                                ]}
                                classNamePrefix="filter-custom-select"
                                onChange={(selectedOption) => {
                                    setConsultant(selectedOption.value);
                                }}
                                placeholder="All"
                            />
                        </div>

                        {/* Buttons */}
                        <div className="">
                            <button
                                onClick={() => {
                                    if (enddate < startdate) {
                                        toast.error("End date cannot be before Start date");
                                        return;
                                    }
                                }}
                                className="btn-primary mt-4 hidden"
                            >
                                Generate Report
                            </button>
                        </div>
                        {/* <div>
              <button
                onClick={() => {
                  if (modewiseData.length > 0) {
                    generateExcel(data, modewiseData, user, now);
                  } else {
                    toast.error("Generate Report First");
                  }
                }}
                className="btn-primary mt-4"
              >
                Download
              </button>
            </div> */}
                    </div>
                    <hr className="border" />

                    {/* main body*/}
                    <div className="flex flex-row mx-6 my-2  w-full justify-evenly gap-4 ">
                        {/* Cards section */}
                        {/* <div */}

                    </div>
                </div>

            ) : (
                <AccessRightCard />
            )}
        </>
    );
};

export default OpdDiscountReports;